const NotFoundPage = () => {
  return <p>404 Not Found</p>;
};

export default NotFoundPage;
